import { create } from "zustand"
import DutyService from "../API/DutyService"
import { getCurrentWeek, transformDuty } from "../utils/dutyHelper"

export const useDutyStore = create((set, get) => ({
    duty: {},
    setDuty: (newDuty) => set({ duty: newDuty }),
    fetchDuty: async (subjectId, classId, force) => {
        if ((force || Object.keys(get().duty).length === 0) && subjectId && classId) {
            const date = new Date()
            const month = date.getMonth() + 1
            const year = date.getFullYear()
            const response = await DutyService.getDutySchedule({
                subject_id: subjectId,
                class_id: classId,
                month: month,
                year: year
            })
            if (response?.status === 200) {
                if (response.data?.weeks?.length > 0) {
                    // set({ duty: response.data })
                    const data = transformDuty(response.data)
                    set({ duty: data, week: getCurrentWeek(data) })
                    return
                }

                const createResponse = await DutyService.createDutySchedule({
                    subject_id: subjectId,
                    class_id: classId,
                    month: month,
                    year: year
                })
                if (createResponse?.status === 200) {
                    // set({ duty: createResponse.data.weeks })
                    const data = transformDuty(response.data)
                    set({ duty: data, week: getCurrentWeek(data) })
                }
            }
        }
    },

    week: 0,
    setWeek: (newWeek) => set({ week: newWeek }),
    incWeek: () => set({ week: get().week + 1 }),
    decWeek: () => set({ week: get().week - 1 }),
}))
